import React from 'react'
import Image from 'next/image'
import cx from 'classnames'

import { Row, Rows, Column } from '@/components/layout'
import arrowsIconImg from '@/assets/buy-flow/right-side/arrows-icon.png'
import capterraLogo from '@/assets/buy-flow/right-side/capterra.png'

import styles from './CheckoutSidePassword.module.scss'

export default function CheckoutSidePasswordNeatHome() {
  return (
    <Column center className={cx(styles.background, styles.neatHome)} gap={32} size={66}>
      <Row className={styles.row}>
        <Column>
          <Rows className={styles.left} gap={32}>
            <Rows gap={12}>
              <Image alt="" className={styles.neatLogo} src={arrowsIconImg} />
              <h1>Trusted by<br />Everyday People<br /> Like You</h1>
            </Rows>
            <Rows gap={12}>
              <p>
                “Using Neat for several years now. Just used the reports function for tax purposes and was thoroughly
                impressed with the output. Something I can simply hand to an auditor, if need be. The Neat Cloud is a
                real security blanket.”
              </p>
              <p className={styles.attribution}>Lee J.</p>
            </Rows>
          </Rows>
        </Column>
        <Column center>
          <Image alt="Capterra" src={capterraLogo} />
        </Column>
      </Row>
    </Column>
  )
}
